import React, { Component } from 'react';
import graphLogo from '../../../../public/img/GARP_logo.png';
import DateFilter from '../../../Components-2025/dashboard/DateFilter';
import PerformanceGraph from '../../../Components-2025/dashboard/PerformanceGraph';
import ProgressBar from '../../../Components-2025/dashboard/ProgressBar';
import TabList from '../../../Components-2025/dashboard/TabList';
import ComponentHeader from '../../../common/ComponentHeader';
import graphDataCalculator from '../../../common/graphDataCalculator';
import { messages } from '../../../common/messages';
import {
  answeredCountKey,
  attemptedCountKey,
  chapterNameKey,
  notesStatsTableNameKey,
  notesTableNameKey,
  performanceGraphUserAnsweredCountKey,
  performanceGraphUserAttemptedCountKey,
  questionStatsTableNameKey,
  questionTableNameKey,
} from './ApiAttributesKays';
import apiServiceProvider from './ApiService';
import tabList from './tabList';
import AppRoutes from '../../config/AppRoutes';
export default class index extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      performanceGraphLoaderPart1: true,
      performanceGraphLoaderPart2: true,
      usersBarGraphDataPart1: [],
      usersBarGraphDataPart2: [],
      totalUsersBarGraphDataPart1: [],
      totalUsersBarGraphDataPart2: [],
      barLabelPart1: [],
      barLabelPart2: [],
      //^ progress bar state stated here
      questionProgressBarDataPart1: [],
      questionProgressBarDataPart2: [],
      questionProgressBarLoaderPart1: true,
      questionProgressBarLoaderPart2: true,
      notesProgressBarDataPart1: [],
      notesProgressBarDataPart2: [],
      notesProgressBarLoaderPart1: true,
      notesProgressBarLoaderPart2: true,
      startDate: '',
      endDate: '',
    };
  }
  //* ============================{{ COMPONENT DID MOUNT START HERE }}==========================================
  async componentDidMount() {
    const { startDate, endDate } = this.state;
    this.getUserPerformanceBarGraph(startDate, endDate, 1);
    this.getUserPerformanceBarGraph(startDate, endDate, 2);
    this.getTotalUsersPerformanceBarGraph(startDate, endDate, 1);
    this.getTotalUsersPerformanceBarGraph(startDate, endDate, 2);
    this.getQuestionProgressBar(startDate, endDate, 1);
    this.getQuestionProgressBar(startDate, endDate, 2);
    this.getNotesProgressBar(startDate, endDate, 1);
    this.getNotesProgressBar(startDate, endDate, 2);
  }
  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================

  //*=========================={{ PERFORMANCE GRAPH FUNCTION START HERE }}======================================
  getUserPerformanceBarGraph = async (formattedStartDate = '', formattedEndDate = '', level) => {
    this.setState({ [`performanceGraphLoaderPart${level}`]: true });

    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      level,
    };
    const result = await apiServiceProvider['getUserPerformanceBarGraph'](data);
    if (result.success) {
      const usersBarGraphData = await graphDataCalculator(
        result.userAttemptedAndAnsweredCount,
        performanceGraphUserAttemptedCountKey,
        performanceGraphUserAnsweredCountKey,
      );
      this.setState({ [`usersBarGraphDataPart${level}`]: usersBarGraphData });
    }
    this.setState({ [`performanceGraphLoaderPart${level}`]: false });
  };

  getTotalUsersPerformanceBarGraph = async (
    formattedStartDate = '',
    formattedEndDate = '',
    level,
  ) => {
    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      level,
    };
    const result = await apiServiceProvider['getTotalUsersPerformanceBarGraph'](data);
    if (result.success) {
      let totalUsersBarGraphData;
      if (formattedStartDate && formattedEndDate) {
        totalUsersBarGraphData = await graphDataCalculator(
          result.attemptedCount,
          performanceGraphUserAttemptedCountKey,
          performanceGraphUserAnsweredCountKey,
        );
      } else {
        totalUsersBarGraphData = await graphDataCalculator(
          result.attemptedCount,
          attemptedCountKey,
          answeredCountKey,
        );
      }
      const barLabel = await result.attemptedCount.map(chapters => {
        return chapters[chapterNameKey].substring(0, 14);
      });
      this.setState({
        [`totalUsersBarGraphDataPart${level}`]: totalUsersBarGraphData,
        [`barLabelPart${level}`]: barLabel,
      });
    }
    this.setState({ [`performanceGraphLoaderPart${level}`]: false });
  };
  //*=========================={{ PERFORMANCE GRAPH FUNCTION ENDED HERE }}======================================

  //*================================{{QUESTION AND NOTES PROGRESS BAR FUNCTIONS START HERE }}====================================
  getQuestionProgressBar = async (formattedStartDate = '', formattedEndDate = '', level) => {
    this.setState({ [`questionProgressBarLoaderPart${level}`]: true });
    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      level,
    };
    const result = await apiServiceProvider[`fetchQuestionProgressBar`](data);
    if (result.success) {
      this.setState({
        [`questionProgressBarDataPart${level}`]: result.chapters,
        [`questionProgressBarLoaderPart${level}`]: false,
      });
    }
  };
  getNotesProgressBar = async (formattedStartDate = '', formattedEndDate = '', level) => {
    this.setState({ [`notesProgressBarLoaderPart${level}`]: true });
    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      level,
    };
    const result = await apiServiceProvider[`fetchNotesProgressBar`](data);
    if (result.success) {
      this.setState({
        [`notesProgressBarDataPart${level}`]: result.chapters,
        [`notesProgressBarLoaderPart${level}`]: false,
      });
    }
  };

  //*============================={{QUESTION AND NOTES PROGRESS BAR FUNCTIONS ENDED HERE }}======================================
  render() {
    const { state } = this;
    return (
      <div className='animated fadeIn'>
        <ComponentHeader title={messages.DASHBOARD} className='frm_title_logo_wrap'>
          <img src={graphLogo} className='garpLogo' alt='full logo' />
        </ComponentHeader>

        {['1', '2'].map(level => (
          <div className='row'>
            <div className='col-sm-12 mt-3'>
              {/*//^====================={{ DASHBOARD HEADER START HERE }}===================== */}
              <ComponentHeader title={messages[`FRM_DASHBOARD_PART_${level}`]}>
                <button
                  className='btn btn-primary pointer_class'
                  onClick={() => this.context.router.push({
                    pathname: AppRoutes[`FRM_V2_DETAILS_STATS_LEVEL${level}`],
                  })}
                  // disabled={state[`isButtonDisablePart${level}`]}
                >
                  {messages.DETAILED_STATS}
                </button>
              </ComponentHeader>
              {/*//^====================={{ DASHBOARD HEADER ENDED HERE }}===================== */}
            </div>
            <div className='col-sm-8'>
              {/*//^====================={{ DATE FILTER START HERE }}===================== */}
              <DateFilter
                getUserBarGraph={this.getUserPerformanceBarGraph}
                getTotalUsersBarGraph={this.getTotalUsersPerformanceBarGraph}
                level={level}
              />
              {/*//^====================={{ DATE FILTER ENDED HERE }}===================== */}
              {/*//^====================={{ PERFORMANCE BAR GRAPH START HERE }}===================== */}
              <PerformanceGraph
                barLabel={state[`barLabelPart${level}`]}
                headText={messages.PERFORMANCE}
                tooltipContent={messages.SEPARATE_YOUR_RESULT}
                tooltipPlace='left'
                performanceGraphLoader={state[`performanceGraphLoaderPart${level}`]}
                usersBarGraphData={state[`usersBarGraphDataPart${level}`]}
                totalUsersBarGraphData={state[`totalUsersBarGraphDataPart${level}`]}
              />
              {/*//^====================={{ PERFORMANCE BAR GRAPH ENDED HERE }}===================== */}
              <TabList
                section='favAPIService'
                level={level}
                exam='frm'
                TabHeader={messages.MY_SAVED_ITEM_WITH_FLASH_CARD}
                apiServiceProvider={apiServiceProvider}
                tabList={tabList}
              />
              <TabList
                section='reportAPIService'
                level={level}
                exam='frm'
                TabHeader={messages.MY_REPORTS}
                apiServiceProvider={apiServiceProvider}
                tabList={tabList}
              />
            </div>
            {/*//^======================={{ QUESTION AND NOTES PROGRESS BAR START HERE }}===================== */}
            <div className='col-lg-4'>
              <ProgressBar
                headerName={messages.QUESTION_PROGRESS}
                ProgressBarData={state[`questionProgressBarDataPart${level}`]}
                progressBarLoader={state[`questionProgressBarLoaderPart${level}`]}
                ProgressBarTables={{
                  questionModel: questionTableNameKey,
                  questionStatsModel: questionStatsTableNameKey,
                }}
              />
              <ProgressBar
                headerName='Notes Progress'
                ProgressBarData={state[`notesProgressBarDataPart${level}`]}
                progressBarLoader={state[`notesProgressBarLoaderPart${level}`]}
                countKey={'notesCount'}
                ProgressBarTables={{
                  questionModel: notesTableNameKey,
                  questionStatsModel: notesStatsTableNameKey,
                }}
              />
            </div>
            {/*//^======================={{ QUESTION AND NOTES PROGRESS BAR ENDED HERE }}===================== */}
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Dashboard/index.jsx